import styled from 'styled-components';
import { lighten } from 'polished';

export const Container = styled.div`
  padding: 30px 50px 60px 50px;
  margin-top: 60px;

  > a {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 20px;
    color: #dee2e6;
    transition: text 0.2s;

    &:hover {
      color: ${lighten(0.7, '#dee2e6')};
      text-decoration: underline;
    }
  }

  /* Parte responsiva */
  @media (max-width: 600px) {
    padding: 30px 10px 60px 10px;
  }
`;
